const HEX_COLOR = /^#[0-9a-f]{6}$/i;

export const isHexColor = (value: string): boolean => HEX_COLOR.test(value);

const channel = (hex: string, offset: number): number => {
	const ratio = Number.parseInt(hex.slice(offset, offset + 2), 16) / 255;
	return ratio <= 0.03928 ? ratio / 12.92 : ((ratio + 0.055) / 1.055) ** 2.4;
};

const luminance = (hex: string): number =>
	0.2126 * channel(hex, 1) + 0.7152 * channel(hex, 3) + 0.0722 * channel(hex, 5);

export const contrast = (left: string, right: string): number => {
	const a = luminance(left);
	const b = luminance(right);
	return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
};

const WHITE = "#ffffff";
const BLACK = "#111111";

/**
 * Black or white, whichever reads on `hex`. The same choice the storefront
 * makes for a button label and for text on a background chosen without one.
 */
export const legibleOn = (hex: string): string =>
	contrast(hex, WHITE) >= contrast(hex, BLACK) ? WHITE : BLACK;
